const LAYOUT_MARGIN: number = 30;
const DESTINATION = require("Assets/Images/Survey/destination-icon.svg").default;
const SOURCE = require("Assets/Images/Survey/source-icon.svg").default;

export { LAYOUT_MARGIN, DESTINATION, SOURCE };
